<template>
  <div class="account__img dropdown dropdown--right">
    <button class="account__img__link js-dropdown-toggle" @click="handleDropDown">
      <img :src="fetchImage(account.avatar)" :alt="account.full_name">
    </button>
    <div class="dropdown__inner">
      <div class="account__meta">
        <p class="account__meta__name">{{account.full_name}}</p>
        <p class="account__meta__company">{{account.workspace.name}}</p>
      </div>
      <div class="dropdown__list" style="min-width: 22rem;" @click="hiddenAllDropdown()">
        <button class="dropdown__menu account__wordspace" @click="$router.push('/workspace')">ワークスペース変更</button>
        <button class="dropdown__menu" @click="$router.push('/settings')">アカウント設定</button>
        <button class="dropdown__menu" @click="$router.push('/auth/change-password')">パスワード変更</button>
        <button class="dropdown__menu" @click="handleLogout">ログアウト</button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions} from 'vuex';
  import {fetchImageMixin} from '~/mixins/global';
  import closeDropDownMixin from "~/mixins/closeDropDownMixin";

  export default {
    name: 'f-header-account',
    props: {
      account: {
        type: Object,
        required: true,
      }
    },
    mixins: [fetchImageMixin, closeDropDownMixin],
    methods: {
      ...mapActions({logout: 'frontend/auth/logout'}),
      handleDropDown(e) {
        this.hiddenDropdown(e);
        e.target.parentNode.classList.toggle("open");
      },
      async handleLogout() {
        try {
          const isLogout = await this.logout();
          if (isLogout) {
            await this.$router.push('/auth/login');
          }
        } catch (e) {
          console.log(e);
        }
      }
    }
  }
</script>
